import { BOTTOM_NAV_HEIGHT } from "./bottomNavConfig";

/** Single brand blue for mobile chrome / CTAs */
export const BRAND_BLUE = "#387ED1";
export const BRAND_BLUE_DARK = "#1D5698";

/** Horizontal page gutter on mobile home */
export const MOBILE_GUTTER = 2.5; // 20px in MUI spacing
export const MOBILE_GUTTER_PX = 20;

export const MOBILE_SECTION_GAP = 3; // 24px

export const MOBILE_TITLE_SX = {
  fontSize: { xs: 18, md: "clamp(1.125rem, 1rem + 0.55vw, 1.5rem)" },
  fontWeight: 800,
  letterSpacing: "-0.02em",
  lineHeight: 1.25,
};

export const MOBILE_BODY_MIN = 12;
export const MOBILE_LABEL_MIN = 11;

/** Clear bottom tab bar + small cushion (FAB floats over content). */
export const MOBILE_CONTENT_PB = `calc(${BOTTOM_NAV_HEIGHT}px - 25px + env(safe-area-inset-bottom, 0px))`;

export const MOBILE_ESSENTIAL_SUBTITLES = {
  portfolio: "Model Portfolio using AI",
  onestock: "Stock Ideas",
  protect: "Safeguarding Stocks",
  phc: "Free Portfolio Audit",
};
